var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"c-stories-more-siblings-item-author",class:[
        { 'c-stories-more-siblings-item-author--illustrator': _vm.isIllustrator },
        ("c-stories-more-siblings-item-author--index-" + _vm.itemIndex)
    ]},[_c('p',[_vm._v(_vm._s(_vm.author))])])}
var staticRenderFns = []

export { render, staticRenderFns }